import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import * as serviceWorker from './serviceWorker';
import history from './store/history/history';
import store from './store/root/store.config';
import App from './app/App';
import { LanguageProvider } from './utils/LanguageProvider';
import './assets/faicons/font-awesome';
import './styles/main.scss';
import { Auth0Provider } from './auth/auth';
import { RenderController } from './utils/RenderController';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID as string
};

TagManager.initialize(tagManagerArgs);

const rootElement = document.getElementById('root');
ReactDOM.render(
  <Provider store={store}>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN as string}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID as string}
      audience={process.env.REACT_APP_AUTH0_AUDIENCE as string}
    >
      <ConnectedRouter history={history}>
        <LanguageProvider>
          <React.Fragment>
            <RenderController />
            <App />
          </React.Fragment>
        </LanguageProvider>
      </ConnectedRouter>
    </Auth0Provider>
  </Provider>,
  rootElement,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
